'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = randomQuotes;
exports.byAuthor = byAuthor;

var _uniqueRandomArray = require('unique-random-array');

var _uniqueRandomArray2 = _interopRequireDefault(_uniqueRandomArray);

var _quotes = require('./quotes.json');

var _quotes2 = _interopRequireDefault(_quotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRandomQuote = (0, _uniqueRandomArray2.default)(_quotes2.default);

function randomQuotes() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    if (count === 1) {
        return getRandomQuote();
    }

    var quotesArray = [];
    for (var i = 0; i < count; i++) {
        quotesArray.push(getRandomQuote());
    }
    return quotesArray;
}

function byAuthor(author) {
    return _quotes2.default.filter(function (quote) {
        return quote.author === author;
    }).map(function (quote) {
        return quote.body;
    });
}